export const COMPANY = {
  legalName: 'AmiroAmir Ltd',
  email: 'amir@amiroamir.com' as string | null,
  registeredOffice: '483 Green Lanes, London N13 4BS, United Kingdom' as string | null,
  companyNumber: '14848410' as string | null,
  jurisdiction: 'England and Wales' as string | null,
  hostingProvider: 'Cloudflare' as string | null,
  policiesUpdated: '23 September 2026',
};
